import { Injectable } from "@angular/core";

@Injectable()
export class AttributeValuesConstants {
  static readonly FULL_HEIGHT_DIALOG = "full-height-dialog";
  static readonly NAVIGATION_DIALOG = "navigation-dialog";
  static readonly SCAN_CARD_DIALOG = "scan-card-dialog";
}